export type ScrollBox = { scrollTop: number; clientHeight: number; scrollHeight: number };

/** True when the element itself can still absorb the wheel delta. */
export function canScrollFurther(box: ScrollBox, deltaY: number): boolean {
  const overflow = box.scrollHeight - box.clientHeight;
  if (overflow < 1) return false;
  if (deltaY > 0) return box.scrollTop < overflow - 0.5;
  if (deltaY < 0) return box.scrollTop > 0.5;
  return false;
}

/**
 * Walks up from the wheel target and reports whether some inner element should
 * consume the scroll instead of the canvas panning.
 */
export function findScrollTarget(
  target: EventTarget | null,
  boundary: Element | null,
  deltaY: number,
): Element | null {
  let element = target instanceof Element ? target : null;
  while (element && element !== boundary) {
    if (canScrollFurther(element, deltaY)) return element;
    element = element.parentElement;
  }
  return null;
}
